var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCommision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(1.475 1.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0 9.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 3.35,
    height: 6.247,
    rx: 1,
    transform: "translate(0 0.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M1730.905,680.13c-.281-1.157-1.6-.141-2.408.814a8.515,8.515,0,0,1-1.5,1.335l0,0a1.4,1.4,0,0,1-.421.285c-.1.064-.16.1-.16.1l0-.036a5.057,5.057,0,0,1-1.655.236c-.313,0-.548-.018-.617-.024a.29.29,0,0,1,.05-.578,4.538,4.538,0,0,0,2.265-.3c0-.4-.046-.858-.258-1.026-.408-.324-2.5-.364-4.208-.454a2.809,2.809,0,0,0-2.5,1.288v3.944h5.34a5.164,5.164,0,0,0,2.457-.973C1728.132,683.968,1731.186,681.287,1730.905,680.13Z",
    transform: "translate(-1715.297 -679.614)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M1729.937,631.767a2.972,2.972,0,0,0-2.846-2.027,3.792,3.792,0,0,1-5.368,0,2.951,2.951,0,0,0-2.784,2.027,3.111,3.111,0,0,0,.94,3.458l4.215,3.5a.538.538,0,0,0,.687,0l4.216-3.5A3.111,3.111,0,0,0,1729.937,631.767Zm-8.173.817a1.08,1.08,0,1,1,1.08,1.08A1.08,1.08,0,0,1,1721.765,632.585Zm1.476,3.491a.483.483,0,1,1-.739-.624l3.417-4.043a.483.483,0,1,1,.738.624Zm2.792.239a1.08,1.08,0,1,1,1.08-1.08A1.08,1.08,0,0,1,1726.032,636.315Z",
    transform: "translate(-1714.702 -629.74)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCommision);
export default __webpack_public_path__ + "static/media/white_commision.04b697e9c48272ef358d1df67373938e.svg";
export { ForwardRef as ReactComponent };